import "./home.css";

import React from "react";
import { Button } from "@material-ui/core";

import { ENTRY_POINT } from "../../utils/stateTypes";
import testimonialsData from "./testimonialsData";
import Header from "../sections/Header";
import BlockGallery from "../sections/BlockGallery";
import CoverFlowGallery from "../sections/CoverFlowGallery";
import LineSeparator from "../sections/LineSeparator";
import BlockHeading from "../sections/BlockHeading";
import Testimonials from "../sections/Testimonials";
import GreenBlockSection from "../sections/GreenBlockSection";

const GALLERY_IMAGES_1 = {
  [ENTRY_POINT.DEFAULT]: [
    { src: "/images/hm-wedding/hm-block1.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block2.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block3.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block4.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block5.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block6.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block7.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block8.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block9.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block10.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block11.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block12.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block13.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block14.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block15.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-block16.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
  ],
};

const GALLERY_IMAGES_2 = {
  [ENTRY_POINT.DEFAULT]: [
    { src: "/images/hm-wedding/hm-gal1.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal2.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal3.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal4.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal5.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal6.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal7.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
    { src: "/images/hm-wedding/hm-gal8.jpg", alt: "A beautiful wedding moment at Shepstone Gardens & The Great Hall" },
  ],
};

const COVER_IMAGE = {
  [ENTRY_POINT.DEFAULT]: [
    "/images/hm-wedding/cover5.jpg",
  ],
};

const WELCOME_MESSAGE = {
  [ENTRY_POINT.DEFAULT]: [
    "Celebrate your sacred union at Johannesburg's most enchanting venue, beautifully suited for Hindu and Muslim weddings.",
  ],
};

const styles = {
  followButton: {
    fontSize: "1.5em",
    width: "100%",
    height: "100%",
    textTransform: "none",
  },
};

const Home = () => {
  return (
    <div>
      <div className={"header-section-home-page"}>
        <Header
          bgImg={COVER_IMAGE[ENTRY_POINT.DEFAULT]}
          // logo={"/images/TSE-Logo-White2.png"}
          headText={"THE SHEPSTONE EXPERIENCE"}
        />
      </div>

      {/* <LineSeparator noLine />
      <Specials specialsList={specialsData} /> */}

      <LineSeparator noLine />
      <BlockHeading
        headText={WELCOME_MESSAGE[ENTRY_POINT.DEFAULT]}
        noBorder
      />
      <LineSeparator noLine />
      
      <BlockGallery
        images={GALLERY_IMAGES_1[ENTRY_POINT.DEFAULT]}
      />

      <div className={"home-follow-button"}>
        <Button
          href={"https://www.instagram.com/shepstone_gardens/"}
          target={"_blank"}
          variant={"outlined"}
          color={"primary"}
          style={styles.followButton}
        >
          Follow us
        </Button>
      </div>

      <LineSeparator noLine />
      <LineSeparator noLine />
      <LineSeparator noLine />

      <GreenBlockSection
        headText={"your unique event"}
        subHeadText={"Our venue,"}
      >
        <div className={"three-columns"}>
          <p className={"venue-intro-text"}>
            Rooted in elegance and cultural respect, The Shepstone Experience offers a breathtaking setting for Hindu and Muslim weddings. From vibrant, tradition-rich celebrations to intimate religious ceremonies, our venue provides the perfect backdrop for your sacred rituals and joyful gatherings.
          </p>
          <p className={"venue-intro-text"}>
            Our experienced team understands the unique requirements of both Hindu and Muslim weddings — whether it’s accommodating a mandap or stage setup, providing serene spaces for nikah ceremonies, or coordinating multi‑day events such as mehndi, sangeet, or walima. We work closely with you to ensure every detail aligns with your traditions and vision.
          </p>
          <p className={"venue-intro-text"}>
            With a professional team, Shepstone Gardens welcomes every couple with warmth and personalised care. When you celebrate with us, you become part of our family. We honour your customs, support your planning journey, and ensure your wedding unfolds with beauty, meaning, and ease.
          </p>
        </div>
      </GreenBlockSection>

      <LineSeparator noLine />

      <BlockHeading
        headText={"Reviews"}
        noBorder
      />
      <Testimonials testList={testimonialsData} />

      <CoverFlowGallery
        images={GALLERY_IMAGES_2[ENTRY_POINT.DEFAULT]}
      />

    </div>
  );
};

export default Home;

